<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
</script>

<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40">
  <div class="bg-white p-5 rounded-lg shadow-lg">
    <slot></slot>
  </div>
</div>